// ft.js per-capability feature flags / kill switch (Phase 2, item 2e).
//
// Flags are fetched at boot from /api/cookie (d.flags), sourced server-side from
// app_config.ft_flags. The point is a runtime kill switch: a capability that
// misbehaves in soak (e.g. dwell, Phase 8) can be turned OFF server-side WITHOUT
// rolling back ft.js or the correctness fixes it ships alongside.
//
// DEFAULT-SAFE is the whole contract: any missing/blocked/malformed config
// resolves to "all off". readFlags is total (never throws, always returns a
// plain object); flagEnabled is strict-true only. Capture is never gated by a
// flag (INV-9/10/11) — these helpers gate optional capabilities, not the lead
// path. Pure + side-effect-free for the test suite.

// Coerce an untrusted server value into a flags object. Anything that is not a
// plain object (null, array, string, undefined) → {} so every flag reads false.
export function readFlags(raw) {
  if (!raw || typeof raw !== "object" || Array.isArray(raw)) return {};
  return raw;
}

// A capability is enabled only when its flag is strictly boolean true. Truthy
// non-true values (1, "true", "on") do NOT enable — opt-in must be explicit so a
// stray value can never silently turn a capability on.
export function flagEnabled(flags, name) {
  return !!(flags && flags[name] === true);
}
